module.exports = __webpack_public_path__ + "static/media/48365000_2308806602527851_5620976042765189120_o-thumb.118444ff.jpg";